import { Command } from '../Command';
import { generateDefault } from '../../../lib/utils';
import { commandList } from '../../../lib/command-list';

const RequestSetCacheCommand = Command.extend({
  detail: {
    key: String,
    item: Object
  }
}).defaultTo(
  generateDefault({
    action: commandList.SET_ITEM_TO_CACHE
  })
);

const RequestGetCacheCommand = Command.extend({
  detail: {
    key: String
  }
}).defaultTo(
  generateDefault({
    action: commandList.GET_ITEM_FROM_CACHE
  })
);

export { RequestSetCacheCommand, RequestGetCacheCommand };
